export default function JobCardSkeleton() {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
      <div className="p-5 md:p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3 w-full">
            <div className="w-11 h-11 md:w-12 md:h-12 rounded-lg bg-background-200/80 animate-pulse flex-shrink-0" />
            <div className="space-y-2 flex-1">
              <div className="h-4 w-3/4 bg-background-200/80 rounded animate-pulse" />
              <div className="h-4 w-1/2 bg-background-200/80 rounded animate-pulse" />
            </div>
          </div>
          <div className="h-6 w-12 bg-background-200/80 rounded-full animate-pulse flex-shrink-0" />
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-3">
          <div className="h-6 w-24 bg-background-200/80 rounded-full animate-pulse" />
          <div className="h-6 w-28 bg-background-200/80 rounded-full animate-pulse" />
          <div className="h-6 w-20 bg-background-200/80 rounded-full animate-pulse" />
        </div>

        <div className="space-y-2 mb-4">
          <div className="h-4 w-full bg-background-200/80 rounded animate-pulse" />
          <div className="h-4 w-2/3 bg-background-200/80 rounded animate-pulse" />
        </div>

        <div className="flex items-center justify-between">
          <div className="h-4 w-16 bg-background-200/80 rounded animate-pulse" />
          <div className="h-9 w-28 bg-background-200/80 rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  );
}